import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { UseMutationOptions, useQueryClient } from 'react-query';
import http from '../config/http-service';
import { masterProductFamiliesEndpoint } from './use-get-master-product-families-api';

type TData = void;
type TError = AxiosError;
type TVariables = number; // id

type Options = Omit<UseMutationOptions<TData, TError, TVariables>, 'mutationFn'>;
type TReturnType = ReturnType<typeof useMutationWrapper<TData, TError, TVariables>>;

// DELETE ums/v1/cms/master-product-families/:id — 409 if the family still has variants
// (including the auto-created "Generic" one); consumers handle that in onError.
export function useDeleteMasterProductFamilyApi(options?: Options): TReturnType {
  const queryClient = useQueryClient();
  const { onSuccess: userOnSuccess, ...restOptions } = options || {};

  const mutationFn = async (id: TVariables): Promise<TData> => {
    await http.delete(`${masterProductFamiliesEndpoint}/${id}`);
  };

  return useMutationWrapper(mutationFn, {
    mutationKey: [`${masterProductFamiliesEndpoint}/delete`],
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries([masterProductFamiliesEndpoint]);
      userOnSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
}
